<article class="card transparent-card">
  <a class="card-body" [routerLink]="['/pathology', Pathology.alias]">
    <h3 class="card-title">{{ Pathology.title }}</h3>
    <div [innerHTML]="Pathology.body"></div>
  </a>
</article>
